import { simulatorBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getUtm = async () => {
  const { data } = await simulatorBackend.get('/utm', getOptions());
  return data;
};

export const getUf = async () => {
  const { data } = await simulatorBackend.get('/secondary-currency', getOptions());
  return data;
};

export const getIpca = async () => {
  const { data } = await simulatorBackend.get('/ipca', getOptions());
  return data;
};
